import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux'
import { fetchSalesOrderLineWeights, setOrderLineWeights, clearSalesOrderLineWeights } from '../../actions/sales_actions';

import ReturnModal from '../../components/Returns/returnModal';

let returnModal = reduxForm({
    form: 'returnModal',
    // validate
})(ReturnModal);

const selector = formValueSelector('returnModal');

function mapStateToProps(state) {
  const totalWeight = selector(state, 'TotalWeight');
  return {
    totalWeight,

    salesOrderLineWeights: state.salesOrders.salesOrderLineWeights,
    salesOrderLineWeightsIsLoading: state.salesOrders.salesOrderLineWeightsIsLoading,
    salesOrderLineWeightsError: state.salesOrders.salesOrderLineWeightsError,

    salesOrderLineWeightsIsEditing: state.salesOrders.salesOrderLineWeightsIsEditing,
    editSalesOrderLineWeightsSuccess: state.salesOrders.editSalesOrderLineWeightsSuccess,
    editSalesOrderLineWeightsError: state.salesOrders.editSalesOrderLineWeightsError
  }
}

export default connect(mapStateToProps, { fetchSalesOrderLineWeights, setOrderLineWeights, clearSalesOrderLineWeights })(returnModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Returns/returnModal.jsx